import { setData } from "rivals/shared/utils/qa";

function Libsyn({ podcastId }: { podcastId: string }): JSX.Element {
  return (
    <iframe
      allowFullScreen
      height="192"
      src={`https://play.libsyn.com/embed/episode/id/${podcastId}/height/192/theme/modern/size/large/thumbnail/yes/custom-color/87A93A/time-start/00:00:00/playlist-height/200/direction/backward`}
      style={{ border: "none", overflow: "hidden" }}
      title={`libsyn-podcast-${podcastId}`}
      width="100%"
      {...setData("lubsyn-podcast-embed", podcastId)}
    />
  );
}

export default Libsyn;
